/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum MyChartDischargeSummaryAliases {
  AUTOCOMPLETE_ENCOUNTER_TYPE = 'autocomplete-encounter-type',
  AUTOCOMPLETE_SUMMARY_TYPE = 'autocomplete-summary-type',
  BUTTON_DOWNLOAD = 'button-download',
  BUTTON_EMAIL = 'button-email',
  CONTEXTUAL_BAR_DISCHARGE_SUMMARY = 'contextual-bar-discharge-summary',
  DATE_PICKER_INITIAL_DATE = 'date-picker-initial-date',
  DECK_RECEIVED = 'deck-received',
  FETCH_ENCOUNTER_TYPE = 'fetch-encounter-type',
  FETCH_RECEIVED = 'fetch-received',
  FETCH_SUMMARY_TYPE_LIST = 'fetch-summary-type-list',
  FIELD_ENCOUNTER_TYPE = 'field-encounter-type',
  FIELD_SUMMARY_TYPE = 'field-summary-type',
  FILTER_DISCHARGE_SUMMARY = 'filter-discharge-summary',
  FILTER_FIELD_FROM_DATE = 'filter-field-from-date',
  LAYOUT_DISCHARGE_SUMMARY = 'layout-discharge-summary',
  LEGENDS_DISCHARGE_SUMMARY = 'legends-discharge-summary',
  MAPPER_ENCOUNTER_TYPE = 'mapper-encounter-type',
  MAPPER_TYPES = 'mapper-types',
  MY_CHART_DISCHARGE_SUMMARY_CARD = 'my-chart-discharge-summary-card',
  PANEL_DISCHARGE_SUMMARY = 'panel-discharge-summary',
  TEXT_ENCOUNTER_TYPE = 'text-encounter-type',
  TEXT_TYPE = 'text-type',
}
export { MyChartDischargeSummaryAliases };
